<template>
  <div class="mt-3">
    <hr>
    <BCard no-body class="py-2">
        <h3> Sincronizaciones</h3>
        <BCardHeader class="pb-50">
            <h5> {{ $t('Filters') }} </h5>
        </BCardHeader>
        <BCardBody>
            <BRow>
              <BCol cols="12" md="4" class="mb-md-0 mb-2">
                  <label>Acción</label>
                  <VueSelect v-model="actionFilter" :options="actionOptions" class="w-100" :reduce="val => val.value" />
              </BCol>
              <BCol cols="12" md="4" class="mb-md-0 mb-2">
                  <label>Tipo</label>
                  <VueSelect v-model="entityFilter" :options="entityOptions" class="w-100" :reduce="val => val.value" />
              </BCol>
              <BCol cols="12" md="4" class="mb-md-0 mb-2">
                  <label>Estado</label>
                  <VueSelect v-model="statusFilter" :options="statusOptions" class="w-100" :reduce="val => val.value" />
              </BCol>
              
            </BRow>
        </BCardBody>
      </BCard>
    
    <BCard>
      <div class="m-2">
          <BRow>
              <!-- Search -->
            <BCol cols="4">
              <vueSelect v-model="perPage"  :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            </BCol>
            <BCol cols="8">
              <div class="d-flex align-items-center justify-content-between">
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BButton variant="primary" @click.prevent="retryAll"><span class="text-nowrap">Reintentar fallidos</span></BButton>
              </div>
            </BCol>
          </BRow>
  
        </div>

      <BTable responsive ref="syncsTable" id="idSyncsTable" striped :items="fetchSyncs" :fields="fields">
        <template #cell(cmd)="data">
          <span>{{ $t(data.item.cmd) }}</span>
        </template>
        
        <template #cell(entity)="data">
          <span>{{ $t(data.item.entity) }}</span>
        </template>
        <template #cell(status)="data">
          <div>
            <BAvatar :id="`invoice-row-${data.item.id}`" size="32" :variant="`light-${resolveInvoiceStatusVariantAndIcon(data.item.status).variant}`" >
              <FeatherIcon :icon="resolveInvoiceStatusVariantAndIcon(data.item.status).icon" />
            </BAvatar>
            <br>
            <span>{{ resolveInvoiceStatusVariantAndIcon(data.item.status).label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <BButton v-if="data.item.status==-1" variant="danger" @click.prevent="retry(data.item)">Reintentar</BButton>
          <span v-else >-</span>
        </template>

        <template #cell(updated)="data">
          <span>
            {{formatDate(data.item.updated_at)}}
          </span>
        </template>
      </BTable>
      <BPagination class="m-2" v-model="currentPage" :total-rows="totalSyncs" :per-page="perPage"></BPagination>
    </BCard>
  </div>
</template>

<script>
  import { BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormRadioGroup, BTable, BSidebar, VBToggle, BPagination, BAvatar, BCardHeader, BCardBody } from 'bootstrap-vue'
  import { inject, ref, watch } from '@vue/composition-api'
  import { getCountries, getProvinces } from '@/composables/settingsService'
  import { getTaxes, addTax } from '@/composables/taxService'
  import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import Ripple from 'vue-ripple-directive'
  import popups from '@/hooks/popups'
  import store from '@/store'
  import axios from '@axios'
  import { VueSelect } from 'vue-select';
  import dateUtils from '@/hooks/dateUtils'

  export default {
    components: { BRow, BCol, BCard, BFormGroup, BFormInput, BFormRadioGroup, BForm, BButton, TextInputValidated, NumberInputValidated, CheckboxValidated, VSelectValidated, BTable, BSidebar, BPagination, BAvatar, BCardHeader, BCardBody, VueSelect},
    directives: { Ripple, 'b-toogle': VBToggle },
    setup(){
      const { deletePopupAxios, errorToast, successToast } = popups()
      const { formatDate } = dateUtils()
      const syncs=ref([])
      const syncsTable=ref(null)
      const totalSyncs=ref(null)
      const settings = inject('settings')
      const isSortDirDesc = ref(true)
      const currentPage = ref(1)
      const sortBy = ref('id')
      const perPage = ref(10)
      const entityFilter=ref(null)
      const statusFilter=ref(null)
      const actionFilter=ref(null)
      const searchQuery=ref(null)

      const perPageOptions = [10, 25, 50, 100]

      const entityOptions=ref([
          { label: 'Matrículas', value: "enrollments" },
          { label: 'Cursos', value: "courses" },
          { label: 'Estudiantes', value: "students" },
      ])

      const statusOptions=ref([
          { label: 'Ejecutado', value: 1 },
          { label: 'Pendiente', value: 0 },
          { label: 'Fallido', value: -1 },
      ])

      const actionOptions=ref([
          { label: 'Registro', value: 'register' },
          { label: 'Actualización', value: 'update' },
          { label: 'Borrado', value: 'delete' },
          { label: 'Cambio contraseña', value: 'pass_change' },
          { label: 'Estado (estudiantes)', value: 'status' },

      ])

      const fields = [
        { key: 'id', 'label': 'ID' },
        { key: 'cmd', 'label': 'Acción' },
        { key: 'entity', 'label': 'Tipo' },
        { key: 'code', 'label': 'Búsqueda' },
        { key: 'status', 'label': 'Estado' },
        { key: 'updated', 'label': 'Actualizado' },
        { key: 'info', 'label': 'Información' },
        { key: 'actions', 'label': 'Reintentar' }
      ]
      
      watch([currentPage, perPage, entityFilter, statusFilter, actionFilter, searchQuery], () => {
        refetchData()
      })

      const fetchSyncs = (ctx,callback) => {
        axios.get('syncs', {params: {
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          entity: entityFilter.value,
          status: statusFilter.value,
          action: actionFilter.value,
          q: searchQuery.value,          
        }}).then((response)=> {
          syncs.value=response.data.syncs
          console.log(syncs.value)
          totalSyncs.value=response.data.total
          callback(syncs.value)
        })
      }

      const retry = (item) => {
        item.status=0
        axios.put(`/syncs/${item.id}`, item).then((response)=> {
          if (response.data.success) {
            successToast('Actualizado correctamente.')
            refetchData();
          } else {
            errorToast('Error actualizando.')
          }
        })
      }

      const retryAll = () => {
        axios.post('retry-failed').then((response)=> {
          if (response.data.success) {
            successToast('Actualizado correctamente.')
            refetchData();
          } else {
            errorToast('Error actualizando.')
          }

        })
      }


      const refetchData = function() {
        syncsTable.value.refresh()
      }

      const resolveInvoiceStatusVariantAndIcon = function(status) {
        if (status===-1) return { variant: 'danger', icon: 'ArrowUpCircleIcon', label: 'Fallido' }
        if (status===0) return { variant: 'warning', icon: 'InfoIcon', label: 'Pendiente' }
        if (status===1) return { variant: 'success', icon: 'CheckCircleIcon', label: 'Ejecutado' }

        return { variant: 'secondary', icon: 'XIcon' }
      }

    
      return {
        fields,
        settings,
        fetchSyncs,
        syncsTable,
        isSortDirDesc,
        currentPage,
        sortBy,
        perPage,
        totalSyncs,
        resolveInvoiceStatusVariantAndIcon,
        searchQuery,
        entityFilter,
        statusFilter,
        actionFilter,
        perPage,
        entityOptions,
        statusOptions,
        actionOptions,
        perPageOptions,
        retry,
        retryAll,
        formatDate
      }
    },
  }
</script>
